import { Flex } from "@chakra-ui/react";

const ContactCard = ({ children }) => {
  return (
    <Flex
      borderRadius=".5rem"
      p="1.5rem 1rem"
      _hover={{
        backgroundColor: "white",
        boxShadow: "10px 10px 90px 0px rgba(0, 0, 0, 0.02)",
      }}
      align="center"
      flexWrap="wrap"
    >
      {children}
    </Flex>
  );
};

export default ContactCard;
